import styled from 'styled-components'

import { Item as DefaultItem } from 'components/Lists/Expandable/Item/Item'

export const Item = styled(DefaultItem)`
	border: none;
	padding: 0 8px;
`
